import { Link, Button, styled, Box, Stack, Typography } from "fashion/fabrics";
import { YouTubeIcon, SearchIcon } from "fashion/icons";

const LINK_VIDEO_EMBED =
  "https://www.youtube.com/embed/feSNwFdQzzo?si=2WqbbslrBfM7qhzJ&vq=hd1080";
const LINK_YOUTUBE =
  "https://www.youtube.com/playlist?list=PLgfz_-vbGTQSM_SMjJ5jpk_y51k3IEbju";

const VideoIframe = styled("iframe")({
  width: "100%",
  border: "none",
  aspectRatio: "16 / 9", // Maintain 16:9 aspect ratio
});

const CodexMakingProcess = () => (
  <Stack gap={3}>
    <Typography variant="h3" textAlign="center">
      Card making{" "}
      <Box color="secondary.main" component="span" display="inline">
        Process
      </Box>
    </Typography>
    <Typography color="text.secondary" textAlign="center">
      A{" "}
      <Box color="secondary.main" component="span" display="inline">
        5 minutes
      </Box>{" "}
      overview of how to create a card.
    </Typography>
    <Box width="100%" maxWidth="100%">
      <VideoIframe
        src={LINK_VIDEO_EMBED}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </Box>
    <Box margin="auto">
      <Button
        component={Link}
        href={LINK_YOUTUBE}
        target="_blank"
        rel="noreferrer"
        variant="outlined"
        color="secondary"
        startIcon={<SearchIcon />}
        endIcon={<YouTubeIcon />}
      >
        View Playlist
      </Button>
    </Box>
  </Stack>
);

export default CodexMakingProcess;
